<template>
    <div>
        <canvas ref="canvas" class="canvas"></canvas>
        <div>
            <label>Red:</label>
            <input type="range" min="0" max="255" v-model.number="red" @input="updateColor" />
        </div>
        <div>
            <label>Green:</label>
            <input type="range" min="0" max="255" v-model.number="green" @input="updateColor" />
        </div>
        <div>
            <label>Blue:</label>
            <input type="range" min="0" max="255" v-model.number="blue" @input="updateColor" />
        </div>
    </div>
</template>

<script>
export default {


    name: 'ColorOverlayCanvas',
    props: {
        imageUrl: {
            type: String,
            default: 'https://7niu.ztxin.cn/ai/xiniao/user/8744317162696758657T70877851/1716269675865.png'
        }

    },
    data() {
        return {
            image: null,
            canvas: null,
            ctx: null,
            sourceBg: 'https://7niu.ztxin.cn/ai/xiniao/user/874431716172183974G2oUOLqyel/1716172183974.jpg',
            red: 0,
            green: 255,
            blue: 0
        }
    },
    mounted() {
        this.canvas = this.$refs.canvas
        this.ctx = this.canvas.getContext('2d')
        this.loadImage()
    },
    methods: {
        loadImage() {
            this.image = new Image()
            this.image.onload = () => {
                this.srcimage = new Image()

                this.srcimage.onload = () => {
                    this.draw()
                }
                this.srcimage.src = this.sourceBg

            }
            this.image.src = this.imageUrl



        },
        draw() {
            // 设置Canvas的尺寸与图片相同  
            this.canvas.width = this.image.width
            this.canvas.height = this.image.height
            this.ctx.globalCompositeOperation = 'source-over'

            // this.ctx.drawImage(this.srcimage, 0, 0, this.image.width, this.image.height)
            // 绘制原始图像  

            this.ctx.save()


            this.ctx.drawImage(this.image, 0, 0, this.image.width, this.image.height)
            this.ctx.globalCompositeOperation = 'source-atop'
            // 绘制颜色叠加层  
            this.ctx.fillStyle = `rgba(${this.red}, ${this.green}, ${this.blue}, 0.8)`
            this.ctx.fillRect(0, 0, this.image.width, this.image.height)
            // this.ctx.restore()
        },
        updateColor() {
            this.draw()
        }
    }
}  
</script>

<style scoped>
canvas {
    border: 1px solid #000;
}

.canvas {
    width: 400px;
    height: 500px;
}

input {
    width: 140px;
    height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/recolorView/index.vue